import { VFlow } from 'bold-ui'
import { AtendimentoProfissional } from 'graphql/types.generated'
import React from 'react'
import { AcompanhamentoVulnerabilidadeSection } from 'view/atendimentos/detail/soap/aside/acompanhamento-vulnerabilidade/AcompanhamentoVulnerabilidadeSection'
import { IdadeGestacionalAcompanhamentoPreNatal } from 'view/atendimentos/detail/soap/aside/pre-natal/model-acompanhamentoPreNatal'

import { AutorreferidasCard } from './AutorreferidasCard'
import { InformacoesGestacaoAtualCard } from './InformacoesGestacaoAtualCard'
import { ListaProblemasCondicoesCard } from './ListaProblemasCondicoesCard'
import { MedicamentosEmUsoCard } from './MedicamentosEmUsoCard'
import { MedicoesGestacaoCard } from './MedicoesGestacaoCard'
import { ProximosAgendamentosCard } from './ProximosAgendamentosCard'
import { VacinacaoGestacaoCard } from './VacinacaoGestacaoCard'

interface InformacoesGestacaoTabContentProps {
  cidadaoId: ID
  prontuarioId: ID
  atendimentoId: ID
  dataReferencia: Instant
  loading: boolean
  dum: Date
  idadeGestacional: IdadeGestacionalAcompanhamentoPreNatal
  dataInicioGestacao: Date
  dppEcografica: Date
  quantidadeConsultas: number
  dataPrimeiraConsulta: LocalDate
  dataUltimaConsulta: LocalDate
  atendimentosProfUltimaGestacao: AtendimentoProfissional[]
  medicoesPath: string
  vacinacaoPath: string
  agendamentosPath: string
}

export const InformacoesGestacaoTabContent = (props: InformacoesGestacaoTabContentProps) => {
  const {
    cidadaoId,
    prontuarioId,
    atendimentoId,
    loading,
    dataReferencia,
    dum,
    idadeGestacional,
    dataInicioGestacao,
    dppEcografica,
    quantidadeConsultas,
    dataPrimeiraConsulta,
    dataUltimaConsulta,
    atendimentosProfUltimaGestacao,
    medicoesPath,
    vacinacaoPath,
    agendamentosPath,
  } = props

  return (
    <VFlow>
      <InformacoesGestacaoAtualCard
        cidadaoId={cidadaoId}
        atendimentoId={atendimentoId}
        loading={loading}
        dum={dum}
        idadeGestacional={idadeGestacional}
        dataInicioGestacao={dataInicioGestacao}
        dppEcografica={dppEcografica}
        quantidadeConsultas={quantidadeConsultas}
        dataPrimeiraConsulta={dataPrimeiraConsulta}
        dataUltimaConsulta={dataUltimaConsulta}
        dataReferencia={dataReferencia}
      />
      <AcompanhamentoVulnerabilidadeSection
        cidadaoId={cidadaoId}
        dataReferencia={dataReferencia}
        isAcompanhamentoPreNatal
      />
      <MedicoesGestacaoCard
        prontuarioId={prontuarioId}
        dataInicioGestacao={dataInicioGestacao}
        atendimentosProfUltimaGestacao={atendimentosProfUltimaGestacao}
        medicoesPath={medicoesPath}
      />
      <MedicamentosEmUsoCard prontuarioId={prontuarioId} />
      <ListaProblemasCondicoesCard prontuarioId={prontuarioId} dataInicioGestacao={dataInicioGestacao} />
      <AutorreferidasCard cidadaoId={cidadaoId} />
      <VacinacaoGestacaoCard dataInicioGestacao={dataInicioGestacao} vacinacaoPath={vacinacaoPath} loading={loading} />
      <ProximosAgendamentosCard cidadaoId={cidadaoId} agendamentosPath={agendamentosPath} />
    </VFlow>
  )
}
